import useFetchSbpList from '@project/Api/useFetchSbpList';
import React from 'react';
import Button from 'react-bootstrap/Button';
import Col from 'react-bootstrap/Col';
import Modal from 'react-bootstrap/Modal';

const SelectPlatformModal = (props) => {
  const {show, onClose, pending, platforms, orderId, setShownModal, shownModal} = props;

  const {showSbpList, error} = useFetchSbpList({
    orderId,
    setShownModal,
    shownModal,
    onClose,
  });

  return (
    <>
      <Modal size='sm' show={show} centered onHide={onClose}>
        <Col>
          <Modal.Header>
            <Modal.Title className='text-center'>Выберите платформу</Modal.Title>
          </Modal.Header>
          <Modal.Body>
            <div className='d-grid gap-2'>
              {platforms.map((platform) => (
                <Button
                  key={platform.value}
                  variant='primary'
                  disabled={pending}
                  onClick={() => showSbpList(platform.value)}
                >
                  {platform.title}
                </Button>
              ))}
            </div>
            {error && <div className='text-danger mt-2 text-center'>{error}</div>}
          </Modal.Body>
        </Col>
      </Modal>

      <Modal {...shownModal} setShownModal={setShownModal} />
    </>
  );
};

export default SelectPlatformModal;
